import React, { FC } from 'react';

import { Center, Spinner, Stack, Text } from '@chakra-ui/react';

import { QrRedirectViewProps } from './QrRedirect.props';

const QrRedirectView: FC<QrRedirectViewProps> = ({ status, message }) => (
  <Center flex={1} minH="100vh" bg="#fff" px={6}>
    <Stack spacing={4} align="center" maxW="420px" textAlign="center">
      {status !== 'error' ? (
        <>
          <Spinner size="lg" color="primary.500" />
          <Text color="gray.600">Loading...</Text>
        </>
      ) : (
        <>
          <Text fontSize="2xl" fontWeight="bold" color="primary.500">
            Unable to redirect
          </Text>
          <Text color="gray.600">
            {message || 'This QR code could not be resolved.'}
          </Text>
        </>
      )}
    </Stack>
  </Center>
);

export default QrRedirectView;
